'use client'
import { getCore } from '@dynamic-labs-sdk/client/core';
import { StorageService } from '@dynamic-labs/utils';
import { getProjectSettings } from '../../../store/state/projectSettings/projectSettings.js';
import { AUTH_EXPIRES_AT, AUTH_TOKEN, AUTH_MIN_TOKEN } from '../../../utils/constants/localStorage.js';
import { DYNAMIC_AUTH_COOKIE_NAME } from '../../../utils/constants/values.js';
import { isCookieEnabled } from '../../../utils/functions/isCookieEnabled/isCookieEnabled.js';
import { getDynamicClient } from '../../client.js';
import { convertSdkUserToUserProfile } from '../user/convertSdkUserToUserProfile/convertSdkUserToUserProfile.js';
import { raiseUserProfileEvent } from '../user/raiseUserProfileEvent/raiseUserProfileEvent.js';

const storeTokenAndUser = ({ expiresAt, user, jwt, minifiedJwt, }) => {
    // expiresAt is always sent back by the backend, regardless of whether jwt/minifiedJwt are sent or not
    if (expiresAt !== undefined) {
        StorageService.setItem(AUTH_EXPIRES_AT, expiresAt);
    }
    if (jwt && minifiedJwt) {
        StorageService.setItem(AUTH_TOKEN, jwt, {
            priority: ['secureStorage', 'localStorage'],
        });
        StorageService.setItem(AUTH_MIN_TOKEN, minifiedJwt, {
            priority: ['secureStorage', 'localStorage'],
        });
        const projectSettings = getProjectSettings();
        if (projectSettings && isCookieEnabled(projectSettings)) {
            // if cookie is enabled, but the backend returns a JWT, then use JS to store the cookie
            const expireDate = new Date(expiresAt * 1000).toUTCString();
            const authCookie = `${DYNAMIC_AUTH_COOKIE_NAME}=${minifiedJwt}; expires=${expireDate}; path=/; SameSite=Lax`;
            document.cookie = authCookie;
        }
    }
    const { state } = getCore(getDynamicClient());
    const oldUser = state.get().user;
    state.set({
        sessionExpiresAt: new Date(expiresAt * 1000),
        token: minifiedJwt,
        user: user,
    });
    if (user && oldUser)
        raiseUserProfileEvent({ newUser: user, oldUser });
    return convertSdkUserToUserProfile(user);
};

export { storeTokenAndUser };
